const tagLabelActive = {
    0: "default",
    1: "green"
}
const stateStr = {
    0: "PENDING",
    1: "PROGRESS",
    2: "DONE",
    3: "ERROR",
    99:"WAITING"
}
const stateColor = {
    0: "pending",
    1: "progress",
    2: "success",
    3: "error",
    99: "waiting"
}
const stateColorNew = {
    0: "#a3a3a3",
    1: "#ffa726",
    2: "#2e7d32",
    3: "#d32f2f",
    99:"#a3a3a3"
}
const formatNumber = (num, digit) => {
    if (num) {
        return num.toFixed(digit).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    return null;
}

const formatNumberZero = (num, digit) => {
    if (num) {
        return num.toFixed(digit).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    return 0;
}


const CovertJson = (value) => {
    if (value) {
        let data = JSON.parse(value);

        return data.toString();
    }
};

const msgIdSuccessList = () => {
    return [{ name: "customer", id: "1201" },
            { name: "so", id: "2101" }, 
            { name: "ar", id: "2201" }, 
            { name: "delivery", id: "2301" },
            { name: "incoming", id: "3401" }
        ];
};

export {
    tagLabelActive,
    formatNumber,
    CovertJson,
    formatNumberZero,
    stateStr,
    stateColor,
    msgIdSuccessList,
    stateColorNew
}